// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.setting-subtitle[data-v-4038d96e] {\n  color: #B8B8B8;\n  font-size: 16px;\n}\n.tax-owner--container[data-v-4038d96e] {\n  width: 260px;\n}\n", ""]);
// Exports
module.exports = exports;
